import { useCallback, useEffect, useState } from 'react';
import { Video } from '../types';

function duration(seconds: number) {
  const h = Math.floor(seconds / 3600), m = Math.floor((seconds % 3600) / 60), s = seconds % 60;
  return `PT${h ? `${h}H` : ''}${m ? `${m}M` : ''}${s || (!h && !m) ? `${s}S` : ''}`;
}

export function useRising(region: string, category: string, enabled: boolean) {
  const [videos, setVideos] = useState<Video[]>([]);
  const [isLoading, setLoading] = useState(enabled);
  const [error, setError] = useState<string | null>(null);
  const [fetchedAt, setFetchedAt] = useState<string | null>(null);
  const refetch = useCallback(async () => {
    if (!enabled) return;
    setLoading(true); setError(null);
    try {
      const res = await fetch(`/api/rising?${new URLSearchParams({ region, category, limit: '100' })}`);
      const data = await res.json() as { error?: string; generatedAt: number; videos: Array<Record<string, unknown>> };
      if (!res.ok) throw new Error(data.error || 'Failed to fetch rising videos');
      setVideos(data.videos.map((v) => ({
        id: String(v.videoId), title: String(v.title), channelId: String(v.channelId), channelTitle: String(v.channelTitle),
        thumbnail: String(v.thumbnailUrl), viewCount: Number(v.viewCount), publishedAt: new Date(Number(v.lastSnapshotAt) * 1000).toISOString(),
        duration: duration(Number(v.durationSeconds)), durationSeconds: Number(v.durationSeconds), deltaViews: Number(v.deltaViews),
        deltaPerHour: Number(v.deltaPerHour), isShort: Boolean(v.isShort),
      })));
      setFetchedAt(new Date(data.generatedAt).toISOString());
    } catch (e) { setError(e instanceof Error ? e.message : 'Unexpected error'); setVideos([]); }
    finally { setLoading(false); }
  }, [region, category, enabled]);
  useEffect(() => { refetch(); }, [refetch]);
  return { videos, isLoading, error, fetchedAt, refetch };
}
